import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button, Select } from '../_atoms';
import { CardItem } from './card_item';
import Spinner from '../styles/images/spinner.gif';
import collectProductVariants from '../helpers/collectProductVariants';
import { ROUTES } from '../constants';
import '../styles/card.scss';

export const Card = ({ basket, loading, ...props }) => {
  const {
    handleChange,
    changeFotobook,
    formObj,
    payFunction,
    error,
    promoCode,
    delivery,
    deliverError,
    shippingCountry,
    shippingType,
    deleteFotobook,
    massDeliverPrice,
    getExactPrice,
  } = props;

  const selectedDeliveryIndex = delivery.findIndex(el => el.id === (shippingType.id || 'russian_post'));

  const buildRequesObj = () => {
    const { product_variants, accomp_products } = collectProductVariants(basket);
    return { product_variants, accomp_products };
  };

  const checkPrice = async () => {
    const req = buildRequesObj();
    req.shipping_type_id = props.shippingType.child || props.shippingType.id;
    req.promo_code = props.promoCode;
    props.checkPromocode(req);
  };

  useEffect(() => {
    if (delivery.length) {
      props.takeAllPrice(buildRequesObj());
    }
  }, [delivery.length]);

  const massOfOrder = basket.map(item => (
    <CardItem
      key={item.id}
      item={item}
      deleteFotobook={deleteFotobook}
      changeFotobook={changeFotobook}
      massDeliverPrice={massDeliverPrice[selectedDeliveryIndex]?.details || []}
    />
  ));
  let country = null;
  let courierType = null;
  const deliveryType = delivery.map((item, index) => {
    if (item.items) {
      const cities = item.items[shippingCountry]?.items || [];
      const citiesGroup = Object.entries(item.items).map(([id, val]) => ({
        value: id,
        label: <div className="selectItem">{val.name}</div>,
      }));
      const elemGroup = cities.map((elem, idx) => ({
        value: elem.serverId,
        label: (
          <div className="selectItem" key={elem.price + idx}>
            <span>{elem.fullName}</span>
            <span>{elem.price} р.</span>
          </div>
        ),
        item: elem,
        parentID: item.id,
      }));
      country = (
        <Select
          classNamePrefix="custom-select"
          options={citiesGroup}
          disabled={item.id !== shippingType.id}
          placeholder="Выберите страну доставки"
          onChange={e => {
            handleChange({
              target: {
                name: 'shippingCountry',
                value: e.value,
              },
            });
          }}
        />
      );
      courierType = shippingCountry ? (
        <Select
          classNamePrefix="custom-select"
          options={elemGroup}
          disabled={item.id !== shippingType.id}
          placeholder="Выберите город доставки"
          onChange={e => {
            getExactPrice({ ...buildRequesObj(), shipping_type_id: e.value, promo_code: promoCode });
            handleChange({
              target: {
                name: 'shippingType',
                value: {
                  id: e.parentID,
                  child: e.value,
                },
              },
            });
          }}
        />
      ) : null;
    }
    return (
      <div className="radio_row">
        <div>
          <label className="radio" key={item.id}>
            <input
              type="radio"
              name="shippingType"
              value={item.id}
              onChange={e =>
                handleChange({
                  target: {
                    name: e.target.name,
                    value: {
                      id: item.id,
                    },
                  },
                })
              }
              checked={item.id === shippingType.id}
            />
            <div className="radio_text">{`${item.shortName}`}</div>
          </label>
        </div>
        <div className="basket-price">
          {typeof massDeliverPrice[index]?.shipping_price !== 'number' ? (
            <img src={Spinner} className="gifSpinner" alt="" />
          ) : (
            `${index > 1 ? 'от' : ''} ${massDeliverPrice[index]?.shipping_price} р.`
          )}
        </div>
      </div>
    );
  });

  const price =
    massDeliverPrice.find(item => item.id === shippingType.child) ||
    massDeliverPrice.find(item => item.id === (shippingType.id || 'russian_post'));

  return (
    <div className="card-page">
      <h1 className="books-page-title">Ваш заказ</h1>
      <div className="card-item-wrapper">{massOfOrder}</div>
      <Link to={ROUTES.PORTAL}>
        <Button className="button-check-payment continue-order blue">Продолжить покупки</Button>
      </Link>
      <p className="card-form-title">Введите адрес доставки</p>
      <div id="card_form" className="card-form">
        <div className="card-form-white">
          <p className="card-form-subtitle">Адрес</p>
          <label className="card-form-label required">
            <input
              className={`card-form-input required ${!formObj.name && error ? 'error' : ''}`}
              type="text"
              name="name"
              id="name"
              placeholder="ФИО"
              value={formObj.name}
              onChange={handleChange}
            />
          </label>
          <label className="card-form-label required">
            <input
              className={`card-form-input required ${!formObj.country && error ? 'error' : ''}`}
              type="text"
              name="country"
              id="country"
              placeholder="Страна"
              value={formObj.country}
              onChange={handleChange}
            />
          </label>
          <label className="card-form-label required">
            <input
              className={`card-form-input required ${!formObj.city && error ? 'error' : ''}`}
              type="text"
              name="city"
              id="city"
              placeholder="Город"
              value={formObj.city}
              onChange={handleChange}
            />
          </label>
          <label className="card-form-label required">
            <input
              className={`card-form-input required ${!formObj.street && error ? 'error' : ''}`}
              type="text"
              name="street"
              id="street"
              placeholder="Улица"
              value={formObj.street}
              onChange={handleChange}
            />
          </label>
          <label className="card-form-label required">
            <input
              className={`card-form-input required ${!formObj.house && error ? 'error' : ''}`}
              type="text"
              name="house"
              id="house"
              placeholder="Дом"
              value={formObj.house}
              onChange={handleChange}
            />
          </label>
          <label className="card-form-label">
            <input
              className="card-form-input"
              type="text"
              name="apartment"
              id="apartment"
              placeholder="Кв."
              value={formObj.apartment}
              onChange={handleChange}
            />
          </label>
          <label className="card-form-label required">
            <input
              className={`card-form-input required ${!formObj.email && error ? 'error' : ''}`}
              type="email"
              name="email"
              id="email"
              placeholder="Email"
              value={formObj.email}
              onChange={handleChange}
            />
          </label>
          <label className="card-form-label required">
            <input
              className={`card-form-input required ${!formObj.tel && error ? 'error' : ''}`}
              type="tel"
              name="tel"
              id="tel"
              placeholder="Телефон"
              value={formObj.tel}
              onChange={handleChange}
            />
          </label>
          <label className="card-form-label">
            <input
              className="card-form-input"
              type="text"
              name="index"
              id="index"
              placeholder="Индекс"
              value={formObj.index}
              onChange={handleChange}
            />
          </label>
          <div className="divider" />
          <p className={`card-form-subtitle delivery ${!shippingType.id && deliverError ? 'deliverError' : ''}`}>
            Выберите способ доставки
          </p>
          <div className={`books-item-radio ${!shippingType.id && deliverError ? 'deliverError' : ''}`}>
            {deliveryType}
          </div>
          <p className="card-form-delivery">Курьерская доставка осуществляется в города, указанные в списке:</p>
          {shippingType.id === 'courier_cities' && (
            <>
              <ul className={`card-form-delivery-list ${!shippingType.id && deliverError ? 'deliverError' : ''}`}>
                {country}
              </ul>
              <ul className={`card-form-delivery-list ${!shippingType.id && deliverError ? 'deliverError' : ''}`}>
                {courierType}
              </ul>
            </>
          )}
        </div>
        <label className="card-form-label promo">
          <input
            className="card-form-input"
            type="text"
            name="promoCode"
            id="promo"
            placeholder="Промо код"
            value={promoCode}
            onChange={handleChange}
          />
          <Button className="button-form-promo" onClick={checkPrice} />
        </label>
        <ul className="card-form-check">
          <li className="card-form-check-item">
            Заказ
            <span>
              {price && !loading ? price.products_price || 0 : <img src={Spinner} className="gifSpinner" alt="" />}
            </span>
          </li>
          <li className="card-form-check-item">
            Скидка
            <span>{price && !loading ? price.discount || 0 : <img src={Spinner} className="gifSpinner" alt="" />}</span>
          </li>
          <li className="card-form-check-item">
            Упаковка и доставка
            <span>
              {price && !loading ? price.shipping_price || 0 : <img src={Spinner} className="gifSpinner" alt="" />}
            </span>
          </li>
          <li className="card-form-check-item">
            Итого
            <span className="rur">p.</span>
            <span>
              {price && !loading ? (
                (price.products_price - price.discount + (price.shipping_price || 0)).toFixed(2)
              ) : (
                <img src={Spinner} className="gifSpinner" alt="" />
              )}
            </span>
          </li>
        </ul>
        <Button className="button-check-payment blue" value="payment" onClick={payFunction}>
          Оплатить
        </Button>
      </div>
    </div>
  );
};
